import { AxiosInstance, CancelToken } from "axios";
import { PickupLocation } from "../types/pickup-location.interface";

export class PickupPointApi {
  constructor(private axios: AxiosInstance) {}

  getLPXLocations(
    query?: string,
    cancelToken?: CancelToken
  ): Promise<PickupLocation[]> {
    return this.axios
      .get<{ results: PickupLocation[] }>("/lpx_terminals", {
        params: { term: query },
        cancelToken,
      })
      .then((r) => r.data.results);
  }

  getOmnivaLocations(
    query?: string,
    cancelToken?: CancelToken
  ): Promise<PickupLocation[]> {
    return this.axios
      .get<{ results: PickupLocation[] }>("/omniva_terminals", {
        params: { query },
        cancelToken,
      })
      .then((r) => r.data.results);
  }
}
